// components/Navbar.jsx
import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Icon from "./AppIcon";

const Navbar = ({
  user = null,
  isAuthenticated = false,
  onSidebarToggle,
  onLogout,
  isMobile,
}) => {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);
  const navigate = useNavigate();

  const userMenuItems = [
    { label: "Profile", path: "/profile", icon: "User" },
    // { label: "Settings", path: "/settings", icon: "Settings" },
    { label: "Help", path: "/help", icon: "HelpCircle" },
    { label: "Logout", action: "logout", icon: "LogOut" },
  ];

  const handleUserMenuToggle = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  const handleUserMenuAction = (item) => {
    if (item?.action === "logout") {
      onLogout();
    } else if (item?.path) {
      navigate(item.path);
    }
    setIsUserMenuOpen(false);
  };

  const handleClickOutside = (event) => {
    if (
      userMenuRef?.current &&
      !userMenuRef?.current?.contains(event?.target)
    ) {
      setIsUserMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleKeyDown = (event, action) => {
    if (event?.key === "Enter" || event?.key === " ") {
      event?.preventDefault();
      action();
    }
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <header className="fixed top-0 left-0 right-0 z-1000 bg-card border-b border-border">
      <div className="flex items-center justify-between h-16 px-4 lg:px-6">
        {/* Left Side - Hamburger Menu & Logo */}
        <div className="flex items-center space-x-4">
          {/* Hamburger Menu Button - Only show on mobile */}
          {isMobile && (
            <button
              onClick={onSidebarToggle}
              className="p-2 rounded-md transition-micro hover:bg-muted focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
              aria-label="Toggle sidebar menu"
            >
              <Icon name="Menu" size={20} className="text-foreground" />
            </button>
          )}

          {/* Logo */}
          <Link
            to="/dashboard"
            className="flex items-center space-x-2 transition-micro hover:opacity-80"
            aria-label="ExpenseLoop Home"
          >
            <div className="flex items-center justify-center w-8 h-8 bg-primarys rounded-md">
              <img src="assets/images/logo2x.png"></img>
            </div>
            <span className="text-xl font-semibold text-foreground">
              Expense<span className="text-[#FF6B35]">Loop</span>
            </span>
          </Link>
        </div>

        {/* Right Side - User Menu */}
        <div className="flex items-center">
          <div className="relative" ref={userMenuRef}>
            <button
              onClick={handleUserMenuToggle}
              onKeyDown={(e) => handleKeyDown(e, handleUserMenuToggle)}
              className="flex items-center space-x-2 p-2 rounded-md transition-micro hover:bg-muted focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
              aria-expanded={isUserMenuOpen}
              aria-haspopup="true"
              aria-label="User menu"
            >
              <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                <span className="text-sm font-medium text-primary-foreground">
                  {user?.name ? user?.name?.charAt(0)?.toUpperCase() : "U"}
                </span>
              </div>
              <Icon
                name="ChevronDown"
                size={16}
                className={`hidden sm:block transition-transform duration-200 ${
                  isUserMenuOpen ? "rotate-180" : ""
                }`}
              />
            </button>

            {/* User Dropdown Menu */}
            {isUserMenuOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-popover border border-border rounded-md shadow-elevated z-1010">
                <div className="py-1" role="menu" aria-orientation="vertical">
                  {user && (
                    <div className="px-4 py-2 border-b border-border">
                      <p className="text-sm font-medium text-foreground">
                        {user?.name || "User"}
                      </p>
                      <p className="text-xs text-muted-foreground truncate">
                        {user?.email || "user@example.com"}
                      </p>
                    </div>
                  )}
                  {userMenuItems?.map((item) => (
                    <button
                      key={item?.label}
                      onClick={() => handleUserMenuAction(item)}
                      className="flex items-center space-x-2 w-full px-4 py-2 text-sm text-foreground hover:bg-muted transition-micro"
                      role="menuitem"
                    >
                      <Icon name={item?.icon} size={16} />
                      <span>{item?.label}</span>
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
